import RSA from './rsa';
import LEA from './lea';
/**
 * AES 256 암호화 알고리즘 사용.
 * 
 */
//const KEY = process.env.AES_KEY;

export const EncryptUtil = {

    /**
     * 암호학적으로 안전한 랜덤 키 생성
     * @param {number} length - 생성할 키의 바이트 길이 (기본값: 16)
     * @returns {string} - 16진수 형태의 랜덤 키
     */
    generateSecureKey: (length = 16) => {
        const array = new Uint8Array(length);
        crypto.getRandomValues(array); // 브라우저 내장 보안 랜덤
        
        // 16진수 문자열로 변환
        return Array.from(array, byte => 
            byte.toString(16).padStart(2, '0')
        ).join('');
    },

    /**
     * Base64 형태의 안전한 랜덤 키 생성
     * @param {number} length - 생성할 키의 바이트 길이 (기본값: 16)  
     * @returns {string} - Base64 형태의 랜덤 키
     */
    generateSecureKeyBase64: (length = 16) => {
        const array = new Uint8Array(length);
        crypto.getRandomValues(array);
        return btoa(String.fromCharCode(...array));
    },

    encryptLEA: (data, key) => {
        // LEA 알고리즘을 사용하여 데이터를 암호화
        const encoder = new TextEncoder();
        let keyBytes = encoder.encode(key);

        // LEA는 16, 24, 32바이트 키만 허용하므로 16바이트로 맞춤
        if (keyBytes.length < 16) {
            // 16바이트보다 짧으면 0으로 패딩
            const paddedKey = new Uint8Array(16);
            paddedKey.set(keyBytes);
            keyBytes = paddedKey;
        } else if (keyBytes.length > 16 && keyBytes.length < 24) {
            // 24바이트로 패딩
            const paddedKey = new Uint8Array(24);
            paddedKey.set(keyBytes);
            keyBytes = paddedKey;
        } else if (keyBytes.length > 24 && keyBytes.length < 32) {
            // 32바이트로 패딩
            const paddedKey = new Uint8Array(32);
            paddedKey.set(keyBytes);
            keyBytes = paddedKey;
        } else if (keyBytes.length > 32) {
            // 32바이트로 자르기
            keyBytes = keyBytes.slice(0, 32);
        }

        console.log('🔍 LEA 키 바이트 처리:', {
            originalKeyLength: encoder.encode(key).length,
            adjustedKeyLength: keyBytes.length
        });

        const lea = new LEA(keyBytes);
        const encryptedData = lea.encrypt(encoder.encode(data));
        
        return encodeURIComponent(lea.base64Encode(encryptedData));
    },

    decryptLEA: (data, key) => {
        // LEA 알고리즘을 사용하여 데이터를 복호화
        const encoder = new TextEncoder();
        let keyBytes = encoder.encode(key);

        // LEA는 16, 24, 32바이트 키만 허용하므로 암호화와 동일하게 처리
        if (keyBytes.length < 16) {
            const paddedKey = new Uint8Array(16);
            paddedKey.set(keyBytes);
            keyBytes = paddedKey;
        } else if (keyBytes.length > 16 && keyBytes.length < 24) {
            const paddedKey = new Uint8Array(24);
            paddedKey.set(keyBytes);
            keyBytes = paddedKey;
        } else if (keyBytes.length > 24 && keyBytes.length < 32) {
            const paddedKey = new Uint8Array(32);
            paddedKey.set(keyBytes);
            keyBytes = paddedKey;
        } else if (keyBytes.length > 32) {
            keyBytes = keyBytes.slice(0, 32);
        }

        const lea = new LEA(keyBytes);
        const decoder = new TextDecoder();
        const decryptedData = lea.decrypt(lea.base64Decode(decodeURIComponent(data)));

        return decoder.decode(decryptedData);
    },

    encryptRSA: (data, publicKey, modulus) => {
        const rsa = new RSA();
        // setPublic(modulus, publicKey) 순서 - 둘 다 16진수 문자열
        rsa.setPublic(modulus, publicKey);
        return rsa.encrypt(data);
    },

    // ❌ 주석 처리: 잘못된 복호화 함수 (보안상 위험하고 작동하지 않음)
    // decryptRSA: (data, publicKey, modulus) => {
    //     // 이 함수는 여러 문제가 있음:
    //     // 1. Private Key 대신 Public Key 사용 (복호화 불가능)
    //     // 2. rsa.decrypt 메서드가 존재하지 않음
    //     // 3. 프론트엔드에서 RSA 복호화는 보안상 위험
    //     const rsa = new RSA();
    //     rsa.setPublic(modulus, publicKey);
    //     return rsa.decrypt(data, 'utf8');
    // }
}

